import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import moment from 'moment';

Component('tr-area-line-chart', {
  properties: {
    chartOptions: {
      type: Object,
      default: {},
    },
  },

  ready() {
    this.init_chart();
  },

  init_chart() {
    const chartContainer = this.querySelector('#chart');
    const options = Object.assign({}, {
      title: {
        show: false,
      },
      grid: {
        bottom: 1,
        left: 1,
        right: 1,
        top: 1,
        backgroundColor: 'transparent',
        borderWidth: 0,
        show: true,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'line',
          label: {
            backgroundColor: '#6a7985',
          },
          lineStyle: {
            type: 'dashed',
            opacity: 0.3,
            color: '#000',
          },
        },
        formatter: '{b}<br>{a1}   {c1}<br>{a0}   {c0}',
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisTick: { show: false },
        axisLabel: { show: false },
        axisLine: {
          lineStyle: {
            width: 0,
          },
        },
        data: this.chartOptions.xAxis.data.map(d => moment(d).format('M月D日')),
      },
      yAxis: { show: false },
      series: this.chartOptions.series,
    });
    const chart = window.tower.chart($(chartContainer), options);
    const { echart } = chart;
    echart.dispatchAction({ type: 'showTip', seriesIndex: 0, dataIndex: (this.chartOptions.xAxis.data.length - 1) });
  },
});
